import { AuthConfig } from 'shared';

import { AppSettings } from '../models/app-settings.model';

export function MapAuthConfigFactory(appSettings: AppSettings): AuthConfig {
    return {
        baseUrl: appSettings.url.api.auth,
        usersApiBaseUrl: appSettings.url.api.users,
        whitelistedDomains: appSettings.url.jwtDomainWhitelist,
        blacklistedRoutes: [],
    };
}
